import { request } from '@/utils';

export function getSoftwareUpdateListAPI(){
  return request({ url: '/softwareCheck/admin/getSoftwareUpdate', method: 'GET' });
}

export function addSoftwareUpdateAPI(data){
  // 新增版本
  return request({ url: '/softwareCheck/admin/setUpdate', method: 'POST', data });
}

export function setVersionUnusedAPI(id){
  // 设为不可用
  return request({ url: `/softwareCheck/admin/setVersionUnused?id=${id}`, method: 'POST' });
}
